module.exports = __webpack_public_path__ + "static/media/beer.292c8e1c.svg";